import { dictionary, Language } from "../../utils/dictionary";

export type SemaforoStatus = "red" | "yellow" | "green";

const STATUS_CONFIG: Record<SemaforoStatus, { bg: string; text: string; dot: string; labelKey: string }> = {
  green: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-400", labelKey: "semaforo-optimal" },
  yellow: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-400", labelKey: "semaforo-risk" },
  red: { bg: "bg-red-50", text: "text-red-700", dot: "bg-red-400", labelKey: "semaforo-critical" },
};

interface StatusBadgeProps {
  status: SemaforoStatus;
  language: Language;
  compact?: boolean;
}

export const StatusBadge = ({ status, language, compact = false }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status];
  const label = dictionary[config.labelKey]?.[language] ?? config.labelKey;

  if (compact) {
    return <span className={`inline-block w-2 h-2 rounded-full ${config.dot}`} aria-label={label} />;
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${config.bg} ${config.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {label}
    </span>
  );
};

export default StatusBadge;
